const TRADITION_LABELS = { ashkenazi: 'Ashkenazi', sefaradi: 'Sefaradí', no_amarrados: 'No Amarrados' };
const HILOS_LABELS = { avodat_yad_grueso: 'A Mano Gruesos', avodat_yad_delgado: 'A Mano Delgados', mechona_delgado: 'A Máquina', sin_hilos: 'Sin Hilos' };
const COTTON_LABELS = { cotton_smooth: 'Liso', cotton_edge: 'Acanalado' };
const WHATSAPP_PHONE = '525543233705';

// Builds the wa.me deep link the CUSTOMER sends after paying: "Hola, ya pagué mi pedido…" + summary.
export const buildWhatsAppOrderUrl = (items, addr, totalAmount, method, orderId = null) => {
  const zoneText = addr.zone === 'Otro' ? (addr.zoneOther || 'Otro') : addr.zone;
  const deliveryText = addr.deliverySpec === 'Otro' ? (addr.deliverySpecOther || 'Otro') : addr.deliverySpec;
  const streetLine = addr.interior ? `${addr.street}, Int. ${addr.interior}` : addr.street;
  let msg = `Hola 👋 *¡Ya pagué mi pedido en Mitzva Fit!* 🙌\n\n`;
  if (orderId) msg += `*Pedido:* #${String(orderId).slice(0, 8)}\n`;
  msg += `*Cliente:* ${addr.fullName}\n*Tel:* ${addr.phone}\n`;
  msg += `*Dirección:* ${streetLine}, ${zoneText}\n`;
  if (deliveryText) msg += `*Entrega:* ${deliveryText}\n`;
  msg += `*Pago:* ${method}\n\n*--- Productos ---*\n`;
  items.forEach((item, i) => {
    msg += `\n${i + 1}. *${item.name}*\n   Talla: ${item.size || item.selectedSize}\n`;
    if (item.selectedColor) msg += `   Color: ${item.selectedColor.name}\n`;
    if (item.selectedTradition && !item.noTzitzit) msg += `   Tradición: ${TRADITION_LABELS[item.selectedTradition] || item.selectedTradition}\n`;
    if (item.selectedHilos && !item.noTzitzit) msg += `   Hilos: ${HILOS_LABELS[item.selectedHilos] || item.selectedHilos}\n`;
    if (item.selectedCottonType && item.hasCottonType) msg += `   Algodón: ${COTTON_LABELS[item.selectedCottonType] || item.selectedCottonType}\n`;
    if (item.customSelections) {
      Object.entries(item.customSelections).forEach(([k, v]) => { msg += `   ${k}: ${v}\n`; });
    }
    msg += `   Cant: ${item.quantity} x $${item.price.toFixed(2)} MXN\n`;
  });
  msg += `\n*Total: $${totalAmount.toFixed(2)} MXN*`;
  // wa.me works universally: opens WhatsApp app on mobile, WhatsApp Web/Desktop otherwise
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(msg)}`;
};

// Short "I already paid" message for flows where the full cart is no longer available (e.g. Mercado Pago return)
export const buildPaidNotificationUrl = (orderId, method = null) => {
  let msg = `Hola 👋 *¡Ya pagué mi pedido en Mitzva Fit!* 🙌\n`;
  if (orderId) msg += `*Pedido:* #${String(orderId).slice(0, 8)}\n`;
  if (method) msg += `*Pago:* ${method}\n`;
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(msg)}`;
};
